import { Injectable, computed, effect, inject, signal } from '@angular/core';
import { StoreConfigurationRepositoryService } from 'src/app/core/services/store-configuration/store-configuration-repository.service';
import { Category } from 'src/app/shared/services/common-api.service';

@Injectable({
  providedIn: 'root'
})
export class CategoryManagementService {
  private storeConfigurationRepositoryService = inject(StoreConfigurationRepositoryService);

  private categoryMapSignal = signal<Map<string, Partial<Category>>>(new Map());
  private isInitialized = signal<boolean>(false);

  readonly allCategories = computed(() => this.categoryMapSignal());
  readonly isReady = computed(() => this.isInitialized());

  constructor() {
    effect(() => {
      const bodyConfigurations = this.storeConfigurationRepositoryService.bodyConfigurations();

      if (bodyConfigurations) {
        const categories = bodyConfigurations?.categories || [];
        const newMap = new Map<string, Partial<Category>>();

        const addCategoriesToMap = (cats: Category[]) => {
          cats.forEach(category => {
            const { sub_categories = [], ...rest } = category || {};
            newMap.set(category.id, rest);
            if (sub_categories?.length > 0) {
              addCategoriesToMap(sub_categories);
            }
          });
        };

        addCategoriesToMap(categories);
        this.categoryMapSignal.set(newMap);
        this.isInitialized.set(true);
      }
    });
  }

  getCategoryById(categoryId: string): Partial<Category> | undefined {
    const map = this.categoryMapSignal();
    const category = map.get(categoryId);
    return category ? structuredClone(category) : undefined;
  }



}
